import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dd522e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { reactive,getCurrentInstance,nextTick } from "vue";
import Nav from "@/js/api/model/nav/index.js"
// import headBottom from "@/js/nav/headBottom"
// import headTop from "@/js/nav/headTop"
// import countdown from "@/js/nav/countdown.js"
import miniCi from "@/js/nav/miniCiV5"
import pageHead from "@/js/nav/pageHeadV5"
// import pageHeadDa from "@/js/nav/pageHeadDa"
import Login from "@/js/utils/login";

export default {
  __name: 'index',
  setup(__props) {

window.loginout = Login.loginout
const { proxy } = getCurrentInstance()
const Util = proxy.$Util
const data = reactive({
  navHtml:""//導航欄主欄目數據
})
// let {initCountdown} = countdown
// let {
//   initHeadBottom,
//   headBottomNavInit,
//   takungpaoInit,
//   showNav,
//   headBottomNavColumnInit,
// } = headBottom
// let {
//   initRelateSwiper,
//   initLogin,
//   initDownload,
//   initHeadTopWap,
//   initCanyouLink
// } = headTop
let {
  initMiniCi,
  chooseMiniCiBrowse,
  immediateLook,
  adBoxListLook,
  adReport1
} = miniCi
let {
  initLogin,
  initHotWord,
  initNav,
  initHeadLeft,
  pageHeadScroll,
  initSearch
} = pageHead
// let {
//   pageHeadScroll
// } = pageHead
// let {
//   pageHeadDaInit
// } = pageHeadDa
const getNavData = async ()=>{
  let res = await Nav.columnDataV5()
  if(Util.isNull(res))return
  data.navHtml = res
  nextTick(()=>{
    /*pageHead start*/
    //pageHeadScroll()
    $(".head-left").css("height",window.innerHeight+'px')
    async function pageHeadRun(){
      initLogin()
      await initHotWord()
      initNav()
      initHeadLeft()
      pageHeadScroll()
      initSearch()
    }
    pageHeadRun()
    /*pageHead end*/
    /*headTop start*/
    // initRelateSwiper()
    // initLogin()
    // initDownload()
    // initCanyouLink()
    // initHeadTopWap()
    /*headTop end*/
    // initCountdown()
    /*headBottom start*/
    // if(initHeadBottom()){
    //   headBottomNavInit()
    //   takungpaoInit()
    //   if(!Util.isPc())return showNav()
    //   headBottomNavColumnInit()
    // }
    /*headBottom end*/
    /*pageHeadDa start*/
    // pageHeadDaInit()
    /*pageHeadDa end*/
    /*miniCi start*/
    async function miniCiRun(){
      await initMiniCi()//初始化minici埋点
      chooseMiniCiBrowse()//选择稿件浏览/栏目浏览/管道浏览
      //immediateLook()//頁面加載即展示廣告埋點 - 頂部廣告
      immediateLook(".da-fixed-box-inner-link-v5")//頁面加載即展示廣告埋點 - 首頁懸浮窗廣告
      adBoxListLook()//頁面廣告展示埋點
    }
    miniCiRun()
    /*miniCi end*/
  })
}
getNavData()

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "nav-html",
    innerHTML: data.navHtml
  }, null, 8, _hoisted_1))
}
}

}